module.exports = __webpack_public_path__ + "static/grafika8-f0a1d7b3f91605a0afcac5c0364129a7.png";